// extracted by mini-css-extract-plugin
export default {"body":"Ddi5uG","buttons":"ebHDL1","button":"BOaaR9","conversion":"eIMWpZ","socialButton":"WQ2bPc"};